<template>
  <div v-if="numbersList.length" class="accordion" :id="'accordionExample' + type">
    <div class="card" v-for="(number, index) in numbersList" v-bind:key="index">
      <div class="card-header" :id="'heading' + createCardIdentifier(index)">
        <h2 class="mb-0">
          <button class="btn accordion-btn" type="button" data-toggle="collapse" :data-target="'#collapse' + createCardIdentifier(index)" aria-expanded="true" :aria-controls="'collapse' + createCardIdentifier(index)">
            {{ number.date }}
          </button>
        </h2>
      </div>

      <div :id="'collapse' + createCardIdentifier(index)" class="collapse" v-bind:class="isFisrtRecord(index)" :aria-labelledby="'heading' + createCardIdentifier(index)" :data-parent="'#accordionExample' + type">
        <div class="card-body">
          <ul class="list-group">
            <li class="list-group-item d-flex justify-content-between align-items-center active">
              Numbers
              <span class="">Luck</span>
            </li>
            <app-number :numbers="number_value" :key="number_value.number"  v-for="number_value in number.numbers"></app-number>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="alert alert-primary" style="border-radius: 0;" role="alert">
    <strong>No data found</strong>
  </div>
</template>
<script type="text/babel">
  import Number from './number.vue';
  import axios from 'axios';

  export default {
    created() {
      //console.dir(this.numbersList)  //undefined;
    },
    props: ['numbersList', 'type'],
    methods: {
      isFisrtRecord(index) {
        return {
          show: index == 0
        }
      },

      createCardIdentifier(index) {
        return this.type + index
      }
    },
    components: {
        'app-number':Number
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/numbers-list.vue